export default {
  get_all: { method: "get", url: "api/tipos-instituicoes" },
  show: { method: "get", url: "api/tipos-instituicoes{/id}" },
  store: { method: "post", url: "api/tipos-instituicoes" },
  update: { method: "put", url: "api/tipos-instituicoes{/id}" },
  delete: { method: "delete", url: "api/tipos-instituicoes{/id}" },
  to_select: { method: "get", url: "api/tipos-instituicoes/to-select" },
  categorias_to_select: {
    method: "get",
    url: "api/categorias-instituicoes/to-select",
  },
};
